import { Node } from '@tiptap/core';
import { VueNodeViewRenderer } from '@tiptap/vue-3';
import BibliographyNodeView from './BibliographyNodeView.vue';

export const BibliographyExtension = Node.create({
    name: 'bibliography',

    group: 'block',
    atom: true,
    selectable: true,
    draggable: true,

    parseHTML() {
        return [{ tag: 'div[data-bibliography]' }];
    },

    renderHTML() {
        return [
            'div',
            { 'data-bibliography': '', class: 'bibliography-placeholder' },
            0,
        ];
    },

    addNodeView() {
        return VueNodeViewRenderer(BibliographyNodeView);
    },

    addCommands() {
        return {
            insertBibliography:
                () =>
                ({ chain, state }) => {
                    // Do not insert a second bibliography if one already exists.
                    let exists = false;
                    state.doc.descendants((node) => {
                        if (node.type.name === 'bibliography') {
                            exists = true;

                            return false;
                        }

                        return !exists;
                    });

                    if (exists) {
                        return false;
                    }

                    return chain()
                        .focus('end')
                        .insertContent({ type: 'bibliography' })
                        .run();
                },
        };
    },
});

declare module '@tiptap/core' {
    interface Commands<ReturnType> {
        bibliography: {
            /**
             * Insert the bibliography placeholder block at the end of the document.
             * No-op if one already exists.
             */
            insertBibliography: () => ReturnType;
        };
    }
}
